import {
  PreSalesCancellationReason,
  PreSalesQuestion,
} from '../../dto/model';
import {
  isPreSalesAnswerEmpty,
  PreSalesAnswers,
} from '../../utils/pre-sales-questionnaire-evaluator';

export const PV_COMBINED_INTEREST = 'Interesse an PV und Wärmepumpe';
export const PV_ONLY_INTEREST = 'Interesse nur an einer PV Anlage';

export const isPvOnlyInterest = (interest: unknown): boolean =>
  interest === PV_ONLY_INTEREST;

export const isPvInterested = (interest: unknown): boolean =>
  interest === PV_COMBINED_INTEREST || isPvOnlyInterest(interest);

export type PvStatus =
  | 'NotInterested'
  | 'Cancelled'
  | 'Eligible'
  | 'PvOnlyCancelled'
  | 'PvOnlyEligible';

export const isPvOnlyHeatCancellationReason = (
  reason: PreSalesCancellationReason,
): boolean => reason.product === 'WP'
  && reason.questionKeys.includes('pv_interest');

const requiredPvAnswerKeys = [
  'house_type',
  'pv_roof_shape',
  'pv_roof_material',
  'is_owner_Combi',
] as const;

export const isPvOrSharedQuestion = (question: PreSalesQuestion): boolean =>
  question.product === 'PV' || question.product === 'Both';

export const getPvStatus = (
  answers: PreSalesAnswers,
  cancellationReasons: PreSalesCancellationReason[],
  visibleQuestionKeys: readonly string[],
): PvStatus => {
  const visibleKeys = new Set(visibleQuestionKeys);
  const interest = answers.pv_interest;
  const isPvOnly = isPvOnlyInterest(interest);
  if (!visibleKeys.has('pv_interest') || !isPvInterested(interest)) return 'NotInterested';
  if (cancellationReasons.some((reason) => reason.product === 'PV')) {
    return isPvOnly ? 'PvOnlyCancelled' : 'Cancelled';
  }
  return requiredPvAnswerKeys.every(
    (key) => visibleKeys.has(key) && !isPreSalesAnswerEmpty(answers[key]),
  )
    ? isPvOnly ? 'PvOnlyEligible' : 'Eligible'
    : 'NotInterested';
};
